import { getOrderFulfillmentCTA } from "./shared";
export var Reimbursement = function Reimbursement(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return reimbursementOfShippingCostBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return reimbursementOfShippingCostBuilder(strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getOrderFulfillmentC;
        return (_getOrderFulfillmentC = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC === void 0 ? void 0 : _getOrderFulfillmentC.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getOrderFulfillmentC2, _getOrderFulfillmentC3;
        return (_getOrderFulfillmentC2 = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC2 === void 0 ? void 0 : (_getOrderFulfillmentC3 = _getOrderFulfillmentC2.getLink) === null || _getOrderFulfillmentC3 === void 0 ? void 0 : _getOrderFulfillmentC3.call(_getOrderFulfillmentC2);
      }
    }
  };
};
var reimbursementOfShippingCostBuilder = function reimbursementOfShippingCostBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "n8BFCi",
        defaultMessage: [{
          "type": 0,
          "value": "Obtenir le remboursement des frais d'expédition lorsque vous expédiez par vous-même"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "Rfyot8",
        defaultMessage: [{
          "type": 0,
          "value": "En choisissant l'option Expédier par vous-même, vous pouvez faire appel à votre propre transporteur pour l'envoi de vos commandes. Nous vous remboursons les frais d'expédition au moment de votre versement à concurrence du montant approuvé pour ces commandes. Lorsque vous connaissez leur montant exact, vous pouvez ajouter ou modifier les frais d'expédition et le numéro de suivi sur la page de traitement des commandes à l'« Étape 4. Informations d'expédition »."
        }]
      })];
    }
  };
};